import {Component, Inject} from '@angular/core';
import {FormBuilder, FormControl} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AuthService} from "../../../services/AuthService";
import {IpInfo} from "../../../entities/IpInfo";
import {APIService} from "../../../services/APIService";

@Component({
  selector: 'app-twofactor',
  templateUrl: './twofactor.component.html',
  styleUrls: ['./twofactor.component.css']
})
export class TwofactorComponent {
  constructor(private _formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<TwofactorComponent>,
              protected auth: AuthService,
              protected api: APIService,
              @Inject(MAT_DIALOG_DATA) public ip: IpInfo) {

  }

  approve() {
    this.api.allow2fa().then((a) => {
      this.dialogRef.close();
    })
  }

  reject() {
    this.api.reject2fa().then((a) => {
      this.dialogRef.close();
    })
  }
}
